"use client";
import { useState } from "react";
import { createBrowserSupabase } from "../../lib/supabase/client.js";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function sendLink(e: React.FormEvent) {
    e.preventDefault();
    const { error } = await createBrowserSupabase().auth.signInWithOtp({ email, options: { emailRedirectTo: `${location.origin}/account` } });
    if (error) setError(error.message); else setSent(true);
  }
  const noteStyle: React.CSSProperties = {
    marginTop: "14px",
    padding: "11px 14px",
    borderRadius: "5px",
    font: "500 13px var(--font-body)",
  };
  return (
    <main
      style={{
        minHeight: "calc(100dvh - 64px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
      }}
    >
      <div
        className="darkcard"
        style={{
          width: "100%",
          maxWidth: "420px",
          padding: "clamp(28px, 5vw, 44px)",
          boxShadow: "var(--shadow)",
        }}
      >
        {/* Brand splash — eyebrow · Prata wordmark · brass rule · lede */}
        <div style={{ textAlign: "center" }}>
          <div
            className="eyebrow"
            style={{ color: "var(--brassbr)", letterSpacing: ".2em", fontSize: "12px" }}
          >
            Барбер-аптека · с 1926
          </div>
          <h1
            className="display"
            style={{
              fontSize: "clamp(40px, 9vw, 52px)",
              lineHeight: 1,
              color: "var(--onbar)",
              margin: "16px 0 0",
            }}
          >
            Бриолин
          </h1>
          <div
            style={{ width: "64px", height: "2px", background: "var(--brass)", margin: "18px auto" }}
          />
          <p
            style={{
              font: "400 15px/1.6 var(--font-body)",
              color: "var(--barmuted)",
              maxWidth: "300px",
              margin: "0 auto",
            }}
          >
            Войдите по email — пришлём ссылку для входа. Пароль не нужен.
          </p>
        </div>

        <form
          onSubmit={sendLink}
          aria-label="Вход по email"
          style={{ marginTop: "28px", display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <label htmlFor="login-email" className="eyebrow" style={{ color: "var(--brassbr)" }}>
            Email
          </label>
          <input
            id="login-email"
            className="field"
            type="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", color: "var(--ink)" }}
          />
          <button
            type="submit"
            data-testid="send-magic-link"
            className="btn-p"
            style={{ width: "100%", marginTop: "8px", padding: "13px 18px" }}
          >
            Получить ссылку
          </button>
        </form>

        {sent && (
          <p role="status" data-testid="login-sent" className="s-ok" style={noteStyle}>
            Ссылка отправлена на {email}
          </p>
        )}
        {error && (
          <p role="alert" className="s-err" style={noteStyle}>
            {error}
          </p>
        )}
      </div>
    </main>
  );
}
